/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner } from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner';
import {
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSONTyped,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSONTyped,
} from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner';

/**
 * 
 * @export
 * @interface CreateLeadAdditionalDocumentsRequest
 */
export interface CreateLeadAdditionalDocumentsRequest {
    /**
     * 
     */
    additional_documents: Array<CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner>;
}

/**
 * Check if a given object implements the CreateLeadAdditionalDocumentsRequest interface.
 */
export function instanceOfCreateLeadAdditionalDocumentsRequest(value: object): value is CreateLeadAdditionalDocumentsRequest {
    if (!('additional_documents' in value) || value['additional_documents'] === undefined) return false;
    return true;
}

export function CreateLeadAdditionalDocumentsRequestFromJSON(json: any): CreateLeadAdditionalDocumentsRequest {
    return CreateLeadAdditionalDocumentsRequestFromJSONTyped(json, false);
}

export function CreateLeadAdditionalDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadAdditionalDocumentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'additional_documents': ((json['additional_documents'] as Array<any>).map(CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSON)),
    };
}

export function CreateLeadAdditionalDocumentsRequestToJSON(json: any): CreateLeadAdditionalDocumentsRequest {
    return CreateLeadAdditionalDocumentsRequestToJSONTyped(json, false);
}

export function CreateLeadAdditionalDocumentsRequestToJSONTyped(value?: CreateLeadAdditionalDocumentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additional_documents': ((value['additional_documents'] as Array<any>).map(CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSON)),
    };
}

